import api from '~/api'
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import { Notification } from 'element-ui'

const state = {
  provider: {},
  providers: {},
  providersList: [],
  providerSearching: false,
}

const getters = {
  provider: state => state.provider,
}

const mutations = {
  SET_PROVIDER(state, payload) {
    state.provider = payload
  },
  SET_PROVIDERS(state, { items }) {
    const newProviders = items.reduce((acc, s) => {
      acc[s.id] = s

      return acc
    }, {})

    state.providers = newProviders
  },
  SET_PROVIDERS_LIST(state, payload) {
    state.providersList = payload
  },
  SET_SEARCHING(state, payload) {
    state.providerSearching = payload
  },
}

const actions = {
  async getProvider({ commit }, id) {
    const response = await api.get(`/providers/${id}`)
    const [, success] = response
    commit('SET_PROVIDER', success)
    return response
  },

  async createProvider({ dispatch, commit }, form) {
    const response = await api.post('/providers', form)
    const [error] = response

    if (!error) {
      await dispatch('getProviders')
    }

    return response
  },

  async updateProvider({ commit }, form) {
    const response = await api.patch(`/providers/${form.id}`, form)
    const [, success] = response
    commit('SET_PROVIDER', success)
    return response
  },

  async getProviders({ commit }) {
    const response = await api.post(
      '/search/providers/_search?from=0&size=500'
    )
    const [error, result] = response
    const providers = result.hits.hits.map(item => item._source)

    if (!error) {
      commit('SET_PROVIDERS', { items: providers })
    }

    return [error, providers]
  },

  searchProviders: debounce(async function({ commit }, string) {
    commit('SET_SEARCHING', true)
    const [error, success] = await api.post(
      '/search/providers/_search?from=0&size=10',
      {
        query: {
          wildcard: { 'name.lowercase': `*${String(string)}*` },
        },
      }
    )

    let providersList = []

    if (error) {
      commit('SET_PROVIDERS_LIST', [])
      Notification({
        type: 'error',
        title: 'Error',
        message: error.message,
      })
    } else if (success) {
      providersList = get(success, 'hits.hits', []).map(item => {
        return { label: item._source.name, value: item._id }
      })
      commit('SET_PROVIDERS_LIST', providersList)
    }
    commit('SET_SEARCHING', false)
    return [error, providersList]
  }, 300),
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
